import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, PaymentData } from './types'

export const selectPaymentListEvent = (state: RootState): Event => state.paymentReducer.listEvent

export const selectPaymentList = (state: RootState): ListData => state.paymentReducer.list

export const selectPaymentActionEvent = (state: RootState): Event => state.paymentReducer.actionEvent

export const selectPaymentDetail = (state: RootState): PaymentData | undefined => state.paymentReducer.detail

export const selectPaymentDetailEvent = (state: RootState): Event => state.paymentReducer.detailEvent

export const selectLastCreateID = (state: RootState): number => state.paymentReducer.lastCreateID

export const selectCreditNoteActionEvent = (state: RootState): Event => state.paymentReducer.creditNoteEvent
